import dateSwitch from '@/components/dateSwitch/index.vue';
import preloader from '@/components/preloader/index.vue';
import filters from '@/components/filters/index.vue';
import rating from '@/components/rating/index.vue';
import pagination from '@/components/pagination/index.vue';
import search from '@/components/search/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import Api from '@/utils/api';
import { mapGetters } from 'vuex';
import { ROLE_LSP } from '@/utils/const';

export default {
  components: {
    preloader,
    filters,
    rating,
    pagination,
    dateSwitch,
    search,
    empty,
  },
  data () {
    return {
      reportsData: [],
      responseData: [],
      reportsDataTotal: null,

      dateFilterSwitch: [],

      filterParams: '',
      query: {
        page: 1,
        perPage: 6,
      },

      load: true,
      search: false,
    };
  },
  computed: {
    countPage () {
      return this.reportsData.length + ((this.query.page - 1) * this.query.perPage);
    },
    ...mapGetters({
      userRole: 'userRole',
      currentUser: 'user',
    }),
    showFooter() {
      return this.userRole !== ROLE_LSP;
    },
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', false);
  },
  mounted () {
    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, 1000);
  },
  methods: {
    downloadFile () {
      this.$root.$emit('notification', {
        message: 'In developing',
        type: 'attention',
        show: true,
      });
    },

    dateSwitchJob (item) {
      this.dateFilterSwitch = item.value;
    },

    holderSearch (searchString) {
      this.query.page = 1;
      this.load = true;
      this.search = searchString;
      this.getSearchReports();
    },

    /**
         * Method for reset search text
         */
    resetSearch () {
      this.search = '';
      this.getSearchReports();
    },

    setFilters (params) {
      this.query.page = 1;
      this.load = true;
      this.filterParams = params;
      this.getFiltersReports();
    },

    getSearchReports () {
      Api.search('reports', this.search, this.query)
        .then((data) => {
          this.holderResponse(data);
        });
    },

    getFiltersReports () {
      this.load = true;

      Api.filters
        .sendFilters(this.filterParams, this.query)
        .then((data) => {
          this.holderResponse(data);
        });
    },

    holderResponse (data) {
      if (data.data.Status) {
        this.reportsData = data.data.Data;
        this.reportsDataTotal = data.data.Total;
        this.responseData = data.data;

        this.reportsData.forEach((item) => {
          item.DocumentTypesData = item.DocumentTypesData.replace(/,/g, ', ');
        });
      } else {
        this.reportsData = [];
        this.responseData = [];
        this.reportsDataTotal = null;
      }

      this.load = false;
    },

    sendPage (page) {
      this.query.page = page;

      if (this.search) {
        this.getSearchReports(this.search);
      } else {
        this.getFiltersReports();
      }
    },
  },
};
